import React from "react";
import PageHeader from "components/PageHeader";

const Documents = () => {
    return (
        <>
            <PageHeader/>

            <div className="container mt-5">
                <div className="row">
                    <div className="col-12 text-center font-size-30">
                        Feltöltés alatt...
                    </div>  
                </div>
            </div>

        </>
    )
}

export default Documents;